import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withApollo } from 'react-apollo';
import {
    loadFrameworks,
    loadEnabledFrameworks,
    setLoadingState,
    loadUsers,
    loadSummary,
} from '../redux/actions/complianceActions';
import { addItem } from '../redux/actions/cartActions';
import { signout, loadSettings, loadTenant, loadCompanyProfile } from '../redux/actions/userActions';
import frameworkMapping from '../utils/frameworkMapping';
import { GetSummary } from '../queries/frameworks'
import { GetUsers, GetCompanyProfile} from '../queries/users'
import { GetItemsInCart } from '../queries/cart'
import { GetEnabledModules, GetTenant } from '../queries/users'

// let queryResolved = 0
class DataLoader extends Component {

    constructor(props) {
        super(props);

        this._isMounted = false;
    }

    state = {
        summaryLoading: true,
        usersLoading: true,
        settingsLoading: true,
    }

    signoutUser() {
        this.props.signout();
        this.props.history.push('/');
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps, prevState) {
        (async () => {

            if (this.props.user && this.state.settingsLoading) {
                try {
                    const { data: settingsData } = await this.props.client.query({
                        query: GetEnabledModules(this.props.user["custom:tenant"]),
                        fetchPolicy: 'network-only',
                        skip: this.state.settingsLoading
                    })

                    const { data: tenantData } = await this.props.client.query({
                        query: GetTenant(this.props.user["custom:tenant"]),
                        fetchPolicy: 'network-only',
                        skip: this.state.settingsLoading
                    })

                    if (tenantData && 
                        settingsData && 
                        settingsData.getEnabledModules && 
                        tenantData.tenant &&
                        this._isMounted) {
                            this.setState({
                                settingsLoading: false
                            })
                        this.props.loadSettings(settingsData.getEnabledModules)
                        this.props.loadTenant(tenantData.tenant)
                    }
                    

                } catch (e) {
                    if (e.networkError) {
                        if (e.networkError['statusCode'] === 401) {
                            this.signoutUser()
                        }
                    } else {
                        console.log(e.message)
                    }
                }
            }
        })().catch(error => {
            console.log(error)
        });
    }

    componentDidMount() {
        (async () => {
            // console.log(this.props.user)
            // if (this.props.user) {

            //get summary, and user list
                try {
                    this._isMounted = true
                    const { data: summaryData } = await this.props.client.query({
                        query: GetSummary(),
                        fetchPolicy: 'network-only',
                        skip: this.state.summaryLoading
                    })
                    const { data: userData } = await this.props.client.query({
                        query: GetUsers(),
                        fetchPolicy: 'network-only',
                        skip: this.state.usersLoading
                    })

                    if (summaryData && this._isMounted) {

                        this.props.loadSummary(summaryData.summary);
                        this.props.loadEnabledFrameworks(
                            summaryData.summary.frameworkSummary.filter(f =>
                                f.active === true).map(f =>
                                    frameworkMapping[f.frameworkID]).sort((a, b) =>
                                        a.frameworkID - b.frameworkID))
                        this.props.loadFrameworks(
                            summaryData.summary.frameworkSummary.map(f => {
                                return {
                                    ...frameworkMapping[f.frameworkID],
                                    enabled: f.active
                                }
                            }).sort((a, b) => a.frameworkID - b.frameworkID))
                    }

                    if (userData && userData.users && this._isMounted) {
                        this.props.loadUsers(userData.users);
                    }

                    if (this._isMounted) {
                        this.setState({
                            summaryLoading: false,
                            usersLoading: false
                        }, () => {
                            this.props.setLoadingState(this.state.summaryLoading ||
                                this.state.summaryLoading)
                        })
                    }
                } catch (e) {
                    if (e.networkError) {
                        if (e.networkError['statusCode'] === 401) {
                            this.signoutUser()
                        }
                    } else {
                        console.log(e.message)
                    }
                }

            if (this.props.user) {
                // get enabled modules and tenant details
                try {

                    const { data: companyProfile } = await this.props.client.query({
                        query: GetCompanyProfile(this.props.user["custom:tenant"]),
                        fetchPolicy: 'network-only',
                    })

                    const { data: settingsData } = await this.props.client.query({
                        query: GetEnabledModules(this.props.user["custom:tenant"]),
                        fetchPolicy: 'network-only',
                        skip: this.state.settingsLoading
                    })
                    const { data: tenantData } = await this.props.client.query({
                        query: GetTenant(this.props.user["custom:tenant"]),
                        fetchPolicy: 'network-only',
                        skip: this.state.settingsLoading
                    })

                    if (tenantData && 
                        settingsData && 
                        settingsData.getEnabledModules && 
                        tenantData.tenant &&
                        this._isMounted) {
                            this.setState({
                                settingsLoading: false
                            })
                        this.props.loadSettings(settingsData.getEnabledModules)
                        this.props.loadTenant(tenantData.tenant)
                    }

                    if (companyProfile && this._isMounted) {
                        this.props.loadCompanyProfile(companyProfile.getCompanyProfile);
                    }

                    if (this._isMounted) {
                        
                    }

                } catch (e) {
                    if (e.networkError) {
                        if (e.networkError['statusCode'] === 401) {
                            this.signoutUser()
                        }
                    } else {
                        console.log(e.message)
                    }
                }
            }

            //get items in cart
            try {
                const { data: cartItems } = await this.props.client.query({
                    query: GetItemsInCart(),
                    fetchPolicy: 'network-only'
                })

                if (cartItems &&
                    cartItems.getItemsInCart &&
                    cartItems.getItemsInCart.Items &&
                    this._isMounted) {
                    this.props.addItem(cartItems.getItemsInCart.Items);
                }

            } catch (e) {
                if (e.networkError) {
                    if (e.networkError['statusCode'] === 401) {
                        this.signoutUser()
                    }
                } else {
                    console.log(e.message)
                }
            }
        })()
            .catch(error => {
                console.log(error)
            });
    }

    render() {
        return (
            <div>
                {this.props.children}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.auth.user,
        settings: state.auth.settings
    }
}

export default connect(mapStateToProps, {
    loadFrameworks,
    loadEnabledFrameworks,
    signout,
    loadSummary,
    loadUsers,
    setLoadingState,
    addItem,
    loadSettings,
    loadTenant,
    loadCompanyProfile
})(withRouter(withApollo(DataLoader)));



// WEBPACK FOOTER //
// ./src/app/DataLoader.js